<template>
  <b-sidebar
    id="add-grupo-opcion-sidebar"
    :visible="isAddGrupoOpcionSidebar"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => toggleSidebar(val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ titleForm }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Nombre"
            rules="required"
          >
            <b-form-group>
              <label for="nombre">Nombre </label>
              <small class="text-muted">
                <i
                  class="popover-space"
                >
                  <feather-icon
                    id="popover-nombre"
                    icon="InfoIcon"
                    class="mr-50 fa-red"
                    @click="hidePopover"
                  />
                </i>
              </small>
              <b-form-input
                id="nombre"
                v-model="formData.descripcion"
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-popover
            target="popover-nombre"
            placement="top"
            triggers="hover"
          >
            <template #title>
              Definición de Nombre
            </template>
            <span>
              Representa una clasificación de opciones
            </span>
          </b-popover>
          <validation-provider
            #default="validationContext"
            name="Icono"
            rules="required"
          >
            <b-form-group
              label="Ícono"
              label-for="icono"
            >
              <b-form-input
                id="icono"
                v-model="formData.icono"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="isBusy"
            >
              Guardar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, VBPopover, BPopover,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import store from '@/store'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BPopover,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  model: {
    prop: 'isAddGrupoOpcionSidebar',
    event: 'update:is-add-grupo-opcion-sidebar',
  },
  props: {
    isAddGrupoOpcionSidebar: {
      type: Boolean,
      required: true,
    },
    dataEdit: {
      type: Object,
      required: false,
      default: null,
    },
    formType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  setup(props, { emit }) {
    const titleForm = ref('')
    const isBusy = ref(false)

    const blankData = {
      descripcion: '',
      icono: '',
    }
    const showPopover = () => {
      emit('bv::show::popover', 'popover-nombre')
    }
    const hidePopover = () => {
      emit('bv::hide::popover', 'popover-button-2')
    }
    const formData = ref(JSON.parse(JSON.stringify(blankData)))/* desestructuracion de  blankData */
    const resetData = () => {
      formData.value = JSON.parse(JSON.stringify(blankData))
    }

    const onSubmit = () => {
      isBusy.value = true
      let service = 'gsencuesta/GRUPO_OPCION_CREATE'
      if (props.formType === 'edit') {
        service = 'gsencuesta/GRUPO_OPCION_UPDATE'
      }
      store.dispatch(service, formData.value)
        .then(response => {
          isBusy.value = false
          emit('refetch-data', response)
          emit('update:is-add-grupo-opcion-sidebar', false)
        })
        .catch(error => {
          isBusy.value = false
          emit('error-data', error)
          emit('update:is-add-grupo-opcion-sidebar', false)
        })
    }
    const toggleSidebar = val => {
      emit('update:is-add-grupo-opcion-sidebar', val)
      if (props.formType === 'new') {
        titleForm.value = 'Agregar Grupo Opción'
        resetData()
      }
      if (props.formType === 'edit') {
        formData.value = {
          idGrupoOpcion: props.dataEdit.idGrupoOpcion,
          descripcion: props.dataEdit.descripcion,
          icono: props.dataEdit.icono,
        }
        titleForm.value = 'Editar Grupo Opción'
      }
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)

    return {
      formData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      toggleSidebar,
      titleForm,
      showPopover,
      hidePopover,
      isBusy,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-grupo-opcion-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
.popover-space {
  margin-left: 1%;
  cursor: pointer;
}
</style>
